module.exports = __webpack_public_path__ + "static/media/JM_iconos-07_descargar.db24da7d.svg";